import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import axios from '../../shared/axios/axios';

import { notification, Spin, Modal } from 'antd';

import withErrorHandler from '../../hoc/withErrorHandler';
import * as actions from '../ncFileManager/store/actions';

import SendDialog from '../ncFileManager/fileManager/client/components/SendDialog';

import { fileOwnerTypes } from '../../shared/constants/enums';
import { isArray, isEmpty } from 'lodash';

let root;

const SendPolicyPackage = ({ rootContainer, policyId, agencyId, insuredId }) => {
  root = rootContainer;
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    dispatch(actions.getSendPolicyPackageInfo({ insuredId: insuredId, policyId: policyId })).then((result) => {
      if (!!result && isArray(result.selectedFileIds) && !isEmpty(result.selectedFileIds)) {
        window['ncFileManager'] = {
          policyId: policyId,
          agencyId: agencyId,
          insuredId: insuredId,
          ownerType: fileOwnerTypes.Policy,
          selectedFileIds: result.selectedFileIds,
        };

        setIsLoading(false);
      } else {
        notification.error({
          message: 'Getting policy package info error',
          top: 55,
          duration: 10,
          getContainer: rootContainer,
        });
      }
    });
  }, []);

  const onClose = () => {
    setIsOpen(false);
  };

  return isLoading ? (
    <Modal getContainer={rootContainer} title="Loading..." open={isOpen} onCancel={onClose} onClose={onClose} width={1200} footer={[]}>
      <Spin spinning={isLoading} style={{ maxHeight: 'unset' }} />
    </Modal>
  ) : isOpen ? (
    <SendDialog
      rootContainer={rootContainer}
      selectedFiles={window['ncFileManager']['selectedFileIds'].map((f, index) => {
        return { id: f, order: index, type: 'file' };
      })}
      insuredId={window['ncFileManager']['insuredId']}
      onHide={onClose}
      onSubmit={onClose}
      headerText="Send policy package"
      cancelButtonText="Cancel"
      submitButtonText="Send"
    />
  ) : (
    <></>
  );
};

export default hot(withErrorHandler(SendPolicyPackage, axios, root));
